<template lang='pug'>
#app
	router-view
</template>

<script>
import { RefreshToken } from '@/lib/API';

export default {
	name : 'app',

	data : () => ( {

	} ),

	computed : {
		accessToken() {
			return this.$store.state.accessToken;
		},

		accessTokenExpiry() {
			return this.$store.state.accessTokenExpiry;
		},

		selectedContract() {
			return this.$store.state.selectedContract;
		},
		user() {
			return this.$store.state.user;
		},
	},

	watch : {
		accessToken : {
			immediate : true,
			handler( accessToken ) {

				if ( !accessToken ) {
					return;
				}
				/*
				const { accessTokenExpiry } = this;

				setTimeout( () => {
					RefreshToken()
						.then( ( data ) => {
							this.$store.dispatch( 'setUserStuff', data.user );
							this.$store.dispatch( 'setAccessToken', data );
						} );
				}, accessTokenExpiry - 5000 );
				*/
				if ( this.selectedContract === null ) {
					this.$router.push( { path : '/app/select-contract' } );
				}

			}
		},
		user : {
			immediate : true,
			handler( user ) {
				console.log('CHANGED USER');
				RefreshToken()
					.then( ( data ) => {
						console.log('set contact:');
						console.log(data.user);
						this.$store.dispatch( 'setContact', data );
						console.log(`set access token to: ${data.accessToken}`);
						this.$store.dispatch( 'setAccessToken', data.accessToken );
						console.log(data);
					} );

			}
		},
	},
	methods : {
		handleError(code, message) {
			console.log('Handle Error');
			switch(code) {
				case 401:
				this.$router.push('/');
				break;
				default: break;
			}
			
		}
	}
};
</script>

<style lang="scss">
@import "./assets/scss/custom.scss";
@import "./assets/scss/shapes.scss";
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #026A44;
	height: 100%;
}

#nav {
	padding: 30px;

	a {
		font-weight: 700;
		color: #026A44;

		&.router-link-exact-active {
			color: #026A44;
		}
	}
}
</style>
